<template>
    <svg
   fill="#ffffff"
   width="20px"
   height="20px"
   viewBox="0 0 1920 1920"
   version="1.1"
   id="svg1"
   xmlns:xlink="http://www.w3.org/1999/xlink"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs1">
    <linearGradient
       id="linearGradient7">
      <stop
         style="stop-color:#ffa100;stop-opacity:1;"
         offset="0"
         id="stop8" />
      <stop
         style="stop-color:#fdff00;stop-opacity:1;"
         offset="1"
         id="stop9" />
    </linearGradient>
    <linearGradient
       id="swatch7">
      <stop
         style="stop-color:#f0d410;stop-opacity:1;"
         offset="0"
         id="stop7" />
    </linearGradient>
    <radialGradient
       xlink:href="#linearGradient7"
       id="radialGradient9"
       cx="959.99136"
       cy="959.9695"
       fx="959.99136"
       fy="959.9695"
       r="959.99159"
       gradientTransform="matrix(1,0,0,0.95518493,0,43.021099)"
       gradientUnits="userSpaceOnUse" />
  </defs>
  <path
     d="m 1915.951,737.588 c -10.956,-33.656 -42.014,-56.244 -77.365,-56.244 H 1226.445 L 1037.381,99.244 C 1026.426,65.589 995.367,43 960.017,43 924.666,43 893.494,65.588 882.652,99.245 L 693.475,681.344 H 81.335 c -35.351,0 -66.41,22.588 -77.366,56.244 -10.842,33.657 1.017,70.137 29.591,90.918 l 495.247,359.718 -189.29,582.211 c -10.842,33.657 1.017,70.137 29.704,90.918 14.23,10.39 31.059,15.586 47.661,15.586 16.829,0 33.657,-5.195 47.887,-15.699 l 495.248,-359.718 495.02,359.718 c 28.575,20.894 67.088,20.894 95.775,0.113 28.574,-20.781 40.433,-57.261 29.59,-91.03 l -189.289,-582.1 495.247,-359.717 c 28.687,-20.781 40.546,-57.261 29.59,-90.918 z"
     fill-rule="evenodd"
     id="path1"
     style="fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-opacity:1;fill:url(#radialGradient9)" />
</svg>
</template>
<script>
export default {
    name: 'IconStar',
}
</script>